import React from 'react';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    lineHeight: 1.8,
  },
}));

const StyledTypography = ({ children, ...props }) => {
  const classes = useStyles();
  return (
    <Typography classes={{ root: classes.root }} {...props}>
      {children}
    </Typography>
  );
};

export default StyledTypography;
